// Mounted above every route of a signed-in workspace (App.tsx): binds the
// page's recorder to the workspace and the person signed in (taking over
// what a closed page of theirs left on this device; another person's takes
// on this browser are left for them) and draws the recording bar on every
// page but Record itself. Everything that must outlive a sign-out (pagehide,
// the update hold, the close guard, the Mac app's calls and messages) is
// RecorderLifecycle's, at the App root.

import { useEffect, type ReactNode } from "react";

import { useAuth } from "@/stores/auth";
import { recorder } from "./recorderMedia";
import { ownerKey } from "./recorderModel";
import { RecordingBar } from "./RecordingBar";

export function RecorderProvider({ customerId, children }: { customerId: string; children: ReactNode }) {
  const user = useAuth((s) => s.user);
  const role = useAuth((s) => s.role);
  const agent = useAuth((s) => s.agent);
  useEffect(() => {
    const eng = recorder();
    void eng.bind(customerId, { owner: ownerKey({ role, user, agent: role === "family" ? agent : null }), family: role === "family" });
    return () => eng.unbind();
  }, [customerId, user, role, agent]);

  return (
    <>
      {children}
      <RecordingBar />
    </>
  );
}
